import script from "./PCPartsDetailsCardMainBody.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartsDetailsCardMainBody.vue?vue&type=script&setup=true&lang=js"

import "./PCPartsDetailsCardMainBody.vue?vue&type=style&index=0&id=4bc74e96&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bc74e96"]])

export default __exports__